import { request } from '@/common/utils/request'

/** 获取推荐拜访商家列表 */
export function getRecommendShop(params) {
  return request
    .post({
      url: 'feidian.bdapp.visit.getRecommendShop',
      data: params,
    })
    .then(res => res.data)
    .catch(() => false)
}
